export default "__VITE_ASSET__Bi$qYKZK__"